import { formatAmount, useFormatters } from "@financialharmony/ui";

interface SekEquivalentProps {
  sekAmount: number | null | undefined;
  currency: string;
  exchangeRate?: number | null;
  exchangeRateDate?: string | null;
}

const SEK = "SEK";

export default function SekEquivalent({ sekAmount, currency, exchangeRate, exchangeRateDate }: SekEquivalentProps) {
  const { formatDate } = useFormatters();
  if (currency === SEK || sekAmount === null || sekAmount === undefined) {
    return null;
  }
  return (
    <p className="text-xs text-muted-foreground">
      ≈ {formatAmount(Number(sekAmount))} {SEK}
      {exchangeRate != null && exchangeRateDate && (
        <> @ {exchangeRate.toFixed(4)} ({formatDate(exchangeRateDate, "numeric")})</>
      )}
    </p>
  );
}
